import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";

import { ClipboardScoreActions } from "../../utils/constants";
import { RestrictedNudgeBottomSheet } from "./RestrictedNudgeBottomSheet";

interface NoShowBottomSheetProps {
  modalState: UseModalState;
}

export function NoShowBottomSheet(props: NoShowBottomSheetProps) {
  const { modalState } = props;

  useLogEffect(
    APP_V2_USER_EVENTS.CLIPBOARD_SCORE_NO_SHOW_BOTTOM_SHEET_VIEWED,
    {},
    { enabled: modalState.modalIsOpen }
  );

  return (
    <RestrictedNudgeBottomSheet
      modalState={modalState}
      action={ClipboardScoreActions.NO_CALL_NO_SHOW}
    />
  );
}
